export const achievements = [
    {
        code: 'premier_pas',
        icon: '🚚',
        title: 'Premier pas',
        description: 'Première livraison marquée préparée',
        points: 10,
    },
    {
        code: 'habitue_route',
        icon: '🛣️',
        title: 'Habitué de la route',
        description: '100 livraisons effectuées',
        points: 50,
    },
    {
        code: 'roi_route',
        icon: '🏆',
        title: 'Roi de la route',
        description: '1000 livraisons effectuées',
        points: 200,
    },
    {
        code: 'semaine_parfaite',
        icon: '📅',
        title: 'Semaine parfaite',
        description: 'Aucune annulation sur une semaine',
        points: 75,
    },
    {
        code: 'createure_nuit',
        icon: '🌙',
        title: 'Créature de la nuit',
        description: 'Mode sombre activé',
        points: 15,
    },
    {
        code: 'strategiste',
        icon: '🗺️',
        title: 'Stratège',
        description: '10 trajets optimisés',
        points: 40,
    },
    {
        code: 'specialiste_immuno',
        icon: '⭐',
        title: 'Spécialiste immuno',
        description: '50 livraisons immuno réalisées',
        points: 60,
    },
    {
        code: 'pilier_equipe',
        icon: '👥',
        title: 'Pilier de l\'équipe',
        description: '1 an d\'ancienneté sur l\'app',
        points: 100,
    },
    {
        code: 'noctambule',
        icon: '🦉',
        title: 'Noctambule',
        description: 'Utiliser l\'app entre minuit et 5h du matin',
        points: 30,
    },
    {
        code: 'lundi_blues',
        icon: '😩',
        title: 'Lundi Blues',
        description: 'Ouvrir l\'app un lundi avant 7h',
        points: 20,
    },
    {
        code: 'cartographe',
        icon: '🗺️',
        title: 'Cartographe',
        description: 'Ouvrir la carte patients 10 fois',
        points: 25,
    },
    {
        code: 'matinal',
        icon: '🌅',
        title: 'Lève-tôt',
        description: 'Utiliser l\'app avant 6h du matin',
        points: 30,
    },
    {
        code: 'vendredi',
        icon: '🎉',
        title: 'TGIF',
        description: 'Utiliser l\'app un vendredi',
        points: 10,
    },
    {
        code: 'perfectionniste',
        icon: '🔍',
        title: 'Perfectionniste',
        description: 'Modifier la même livraison 3 fois de suite',
        points: 35,
    },
    {
        code: 'indecis',
        icon: '🤔',
        title: 'L\'indécis',
        description: 'Changer le statut d\'une livraison 5 fois de suite',
        points: 20,
    },
    {
        code: 'weekend_warrior',
        icon: '🏖️',
        title: 'Week-end warrior',
        description: 'Se connecter un samedi ou dimanche',
        points: 25,
    },
    {
        code: 'marathon',
        icon: '🏃',
        title: 'Marathon',
        description: 'Rester connecté plus de 2h',
        points: 30,
    },
    {
        code: 'explorateur',
        icon: '🧭',
        title: 'Explorateur',
        description: 'Visiter toutes les pages de l\'app',
        points: 35,
    },
    {
        code: 'social',
        icon: '🤝',
        title: 'Social',
        description: 'Voir les hauts faits de 3 collègues',
        points: 20,
    },
];